var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6615 23.3359V33.3359M31.6615 33.3359L34.9948 30.0026M31.6615 33.3359L28.3281 30.0026",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6615 19.9974C36.6615 13.712 36.6615 10.5693 34.7088 8.61668C32.7562 6.66406 29.6135 6.66406 23.3281 6.66406H16.6615C10.3761 6.66406 7.23337 6.66406 5.28075 8.61668C3.32812 10.5693 3.32812 13.712 3.32812 19.9974C3.32812 26.2828 3.32812 29.4255 5.28075 31.3781C7.23337 33.3307 10.3761 33.3307 16.6615 33.3307H23.3281",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 26.6641H10",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6615 26.6641H20.8281",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32812 16.6641L36.6615 16.6641",
    stroke: "#EDB755",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall2);
export default __webpack_public_path__ + "static/media/install_2.06c033f72d7a4633c5e4bddbfb6fc653.svg";
export { ForwardRef as ReactComponent };